import React from 'react';
export * from './StaticPropsContext';
export * from './QueryParameterContext';
export * from './SearchResultContext';

import { StaticPropsContextProvider } from './StaticPropsContext';
import { GradeConversionPageInitialProps } from '../../../data/useGradeConversionPageProps';
import { QueryParameterContext } from './QueryParameterContext';
import { SearchResultContextProvider } from './SearchResultContext';

interface GradeConversionContextProvider {
  children: React.ReactNode;
  initialProps: GradeConversionPageInitialProps;
}

export function GradeConversionProvider(props: GradeConversionContextProvider) {
  return (
    <StaticPropsContextProvider initialProps={props.initialProps}>
      <QueryParameterContext>
        <SearchResultContextProvider>{props.children}</SearchResultContextProvider>
      </QueryParameterContext>
    </StaticPropsContextProvider>
  );
}
